export const why_constants = [
  "Agricultural crop monitoring and disease detection",
  "Healthcare diagnostic imaging",
  "Manufacturing quality control",
  "Security and surveillance systems",
  "Retail and e-commerce applications",
];
